import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetArticlePublished extends Http {
  [x: string]: any
  public async getArticleList(data: NLoginApi.getArticleListRequestData) {
    return await super.request<NLoginApi.getArticleListResponse>({
      url: '/crossbowSystem/getArticleList',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async queryPermission(data: NLoginApi.QueryPermissionRequestData) {
    return await super.request<NLoginApi.QueryPermissionResponse>({
      url: '/article/permission',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async createArticle(data: NLoginApi.createArticleRequestData) {
    return await super.request<NLoginApi.createArticleResponse>({
      url: '/article/create',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async updateArticle(data: NLoginApi.updateArticleRequestData) {
    return await super.request<NLoginApi.updateArticleResponse>({
      url: '/article/update',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async uploadImages(data: NLoginApi.uploadImagesRequestData) {
    return await super.request<NLoginApi.uploadImagesResponse>({
      url: '/image/uploadImage',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data
    })
  }

  public async delArticleList(data: NLoginApi.delArticleListRequestData) {
    return await super.request<NLoginApi.delArticleListeResponse>({
      url: '/crossbowSystem/delArticleList',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async articlePublishing(data: NLoginApi.articlePublishingRequestData) {
    return await super.request<NLoginApi.articlePublishingResponse>({
      url: '/crossbowSystem/articlePublishing',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async articleTakenDown(data: NLoginApi.articleTakenDownRequestData) {
    return await super.request<NLoginApi.articlePublishingResponse>({
      url: '/crossbowSystem/articleTakenDown',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getArticle(data: NLoginApi.getArticleRequestData) {
    return await super.request<NLoginApi.getArticleResponse>({
      url: '/crossbowSystem/getArticle',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getDownLoad(data: NLoginApi.getDownLoadRequestData) {
    return await super.request<NLoginApi.getDownLoadResponse>({
      url: '/pdf/download',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data,
      responseType: 'blob'
    })
  }
}

export default GetArticlePublished
